import { createStorageAtomFactory } from '@exodus/atoms';
const createPublicKeysCacheAtom = ({ storage }) => createStorageAtomFactory({ storage })({
    key: 'publicKeys',
});
const publicKeysCacheAtomDefinition = {
    id: 'publicKeysCacheAtom',
    type: 'atom',
    factory: createPublicKeysCacheAtom,
    dependencies: ['storage'],
};
export default publicKeysCacheAtomDefinition;
